import React, { Component } from 'react';
import './App.css';
import News from './News/News';
import SideNews from './News/SideNews';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      news1: {
        type: 'top-headlines',
        query: 'sources=bbc-news&pageSize=6'
      },
      news2: {
        type: 'everything',
        query: 'q=bitcoin&pageSize=6'
      },
      news3: {
        type: 'everything',
        query: 'domains=comicbookmovie.com&language=en'
      },
      trump: {
        type: 'top-headlines',
        query: 'q=trump&pageSize=6'
      }
    }
  }

  render(){
    return(
      <div className="container-fluid">
        <div className="navbar-fixed">
          <nav>
            <div className="nav-wrapper indigo darken-4">
              <a href="/" className="brand-logo center">My Feed</a>
            </div>
          </nav>
        </div>
        <div className="row">
          <div className="col s8">
            <h2 className="App-title center">BBC News</h2>
            <News news={this.state.news1}/>
            <h2 className="App-title center">Bitcoin News</h2>
            <News news={this.state.news2}/>      
            <h2 className="App-title center">Trump News</h2>
            <News news={this.state.trump}/>
          </div>
          <div className="col s4">
            <SideNews news={this.state.news3}/>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
